import React from 'react'
import Logo from '../../assets/logo.png'
import Kapsul from '../../assets/kapsul2.png'
import StoreApple from '../../assets/store_apple.png'
import StoreGoogle from '../../assets/store_google.png'
import BgMobile from '../../assets/bg_mobile.png'

const APP_STORE_URL = 'https://apps.apple.com/us/app/texttonext/id6473700980'
const GOOGLE_PLAY_URL =
  'https://play.google.com/store/apps/details?id=com.texttonext.app'

const DownloadScreen: React.FC = () => {
  return (
    <div
      className="fixed inset-0 w-screen h-screen flex flex-col overflow-hidden"
      style={{
        background: '#181B1E',
        backgroundImage: `url(${BgMobile})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
      }}
    >
      {/* Background Glow */}
      <div className="absolute top-1/3 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[250px] h-[250px] bg-[#DFFF00]/8 rounded-full blur-[80px]" />

      {/* Content */}
      <div className="flex-1 flex flex-col items-center justify-center px-6 relative z-10">
        {/* Logo */}
        <div className="mb-12">
          <img src={Logo} alt="TextToNext" className="h-[25px]" />
        </div>

        {/* Kapsul Image */}
        <div className="mb-12">
          <img
            src={Kapsul}
            alt="Kapsül"
            className="w-auto h-auto max-w-[200px]"
          />
        </div>

        {/* Title */}
        <h2
          className="text-white mb-2 text-center"
          style={{
            fontFamily: 'MorebiRounded, sans-serif',
            fontWeight: 600,
            fontSize: '24px',
            lineHeight: '28px',
          }}
        >
          Daha İyi Bir Deneyim İçin
        </h2>

        <p
          className="text-white text-center max-w-xs mb-16"
          style={{
            fontFamily: 'MorebiRounded, sans-serif',
            fontWeight: 300,
            fontSize: '16px',
            lineHeight: '20px',
          }}
        >
          Uygulamayı indirin
        </p>

        <br />
        {/* Download Buttons */}
        <div className="flex gap-3 justify-center items-center">
          {/* App Store */}
          <a
            href={APP_STORE_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="transition-all active:scale-[0.98]"
          >
            <img
              src={StoreApple}
              alt="App Store"
              style={{ width: '120px', height: '40px' }}
            />
          </a>

          {/* Google Play */}
          <a
            href={GOOGLE_PLAY_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="transition-all active:scale-[0.98]"
          >
            <img
              src={StoreGoogle}
              alt="Google Play"
              style={{ width: '120px', height: '40px' }}
            />
          </a>
        </div>
      </div>
    </div>
  )
}

export default DownloadScreen
